export const DEVICE_EVENT_UNKNOWN_HOSTNAME = 'unknown';
